import { render, staticRenderFns } from "./AllocationHeader.vue?vue&type=template&id=2e12cca7"
import script from "./AllocationHeader.vue?vue&type=script&lang=ts"
export * from "./AllocationHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports